"use client"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useParams } from "next/navigation"

const SignInPrompt = () => {
  const { countryCode } = useParams() as { countryCode: string }
  // After signing in the customer lands on the one-page checkout.
  const next = encodeURIComponent(`/${countryCode}/checkout`)

  return (
    <div className="flex flex-col gap-y-3">
      <p className="zl-label">¿Ya tienes cuenta?</p>
      <p className="text-sm text-zl-steel">
        Inicia sesión y paga en un paso con tus direcciones guardadas.
      </p>
      <LocalizedClientLink
        href={`/account?next=${next}`}
        className="zl-btn-outline"
        data-testid="sign-in-button"
      >
        Iniciar sesión
      </LocalizedClientLink>
    </div>
  )
}

export default SignInPrompt
